import BadgeModal from './BadgeModal';
export default BadgeModal;
